import React from 'react';
import {
    Box,
    Button,
    Container,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TitleBar from '../../components/TitleBar/TitleBar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MetricsTrendingContent from './MetricsTrendingContent';

const MetricsTrending = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
            <TitleBar />
            <Container maxWidth="xl" sx={{ pt: 6, pb: 8 }}>
                <Box sx={{ mb: 3 }}>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate('/reports')}
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 500
                        }}
                    >
                        Back to Reports
                    </Button>
                </Box>

                <MetricsTrendingContent />
            </Container>
        </Box>
    );
};

export default MetricsTrending;
